import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';

// if the fuzzysort uses the { keys: [] } option, then be sure to include the keysIndexTarget positional argument for the target you want to highlight
export function highlightFuzzyResult(
  [fuzzyResult]: [Fuzzysort.Result | Fuzzysort.KeysResult<any>],
  positionalArgs: {
    highlightedClass: string;
    keysIndexTarget?: number;
    valueWhenNull?: string;
  },
) {
  if (
    positionalArgs.keysIndexTarget != null &&
    (fuzzyResult as Fuzzysort.KeysResult<any>)[
      positionalArgs.keysIndexTarget
    ] == null
  ) {
    return positionalArgs.valueWhenNull;
  }

  const open = `<span class="${positionalArgs.highlightedClass}">`;
  const close = '</span>';
  let highlighted: string | null;

  if (positionalArgs.keysIndexTarget == null) {
    highlighted =
      (fuzzyResult as Fuzzysort.Result).highlight?.(open, close) ?? null;
  } else {
    highlighted =
      (fuzzyResult as Fuzzysort.KeysResult<any>)[
        positionalArgs.keysIndexTarget
      ]?.highlight(open, close) ?? null;
  }

  return htmlSafe(highlighted || '');
}

export default helper(highlightFuzzyResult);
